import { connect } from 'react-redux'
import Select from 'react-select'
import filter from 'lodash/filter'
import uniqBy from 'lodash/uniqBy'
import flatten from 'lodash/flatten'
import map from 'lodash/map'
import get from 'lodash/get'
import { setFiltersLoading, setCalendarFiltersForTechnician } from '../../actions/calendar-filters'

const mapStateToProps = (state, ownProps) => {
  const locationId = ownProps.locationId

  const { date } = state.calendarFilters
  if (!date) return { options: [], isLoading: true }

  const year = date.getFullYear(), month = date.getMonth()

  if (!state.calendarFilters[year] || !state.calendarFilters[year][month]) return { options: [], isLoading: true }

  const workOrders = get(state.calendarFilters, `${year}.${month}.workOrders`, [])

  let technicians = uniqBy(flatten(map(workOrders, 'technicians')), 'id')

  if (locationId) {
    technicians = filter(technicians, (tech) => (state.technicians.includes(tech.id)))
  }

  const options = technicians.map((tech) => (
    {
      value: tech.id,
      label: tech.name
    }
  ))

  const { isLoading = false } = state.calendarFilters

  return {
    options,
    isLoading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChange (item) {
      const technicianId = item ? item.value : null

      dispatch(setFiltersLoading(true))
        .then(() => dispatch(setCalendarFiltersForTechnician(technicianId)))
        .then(() => ownProps.onChange(item))
        .then(() => dispatch(setFiltersLoading(false)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/calendar/select-technician-container.js